import React, { Component } from 'react';
import { connect } from 'react-redux';
import { alertSuccess } from '../actions/alertActions';
import { api } from '../services/rest';
import { withRouter } from 'react-router-dom';
import folderRefresh from '../assets/folder-refresh.png';
import folderRemove from '../assets/folder-remove.png';
import folderAdd from '../assets/folder-add.png';
import fileAdd from '../assets/file-upload.png';
import fileRemove from '../assets/file-remove.png';
import { Tooltip } from 'reactstrap';
import Menu from './Menu';

class Resources extends Component {
    constructor(props) {
        super(props);
        this.dropArea = React.createRef();
        this.progressBar = React.createRef();
        this.NewFolderRef = React.createRef();
        this.NewFolderText = React.createRef();
        this.FileContainer = React.createRef();

        this.filesDone = 0;
        this.filesToDo = 0;
        this.highlight = this.highlight.bind(this);
        this.unhighlight = this.unhighlight.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.previewFile = this.previewFile.bind(this);
        this.initializeProgress = this.initializeProgress.bind(this);
        this.progressDone = this.progressDone.bind(this);
        this.processFile = this.processFile.bind(this);
        this.addNameToDataURL = this.addNameToDataURL.bind(this);
        this.removeFolder = this.removeFolder.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.addFolder = this.addFolder.bind(this);
        this.getNewFolderName = this.getNewFolderName.bind(this);
        this.refreshFolder = this.refreshFolder.bind(this);
        this.toggleNewFile = this.toggleNewFile.bind(this);
        this.toggleNewFolder = this.toggleNewFolder.bind(this);
        this.toggleRefreshFolder = this.toggleRefreshFolder.bind(this);
        this.toggleRemoveFile = this.toggleRemoveFile.bind(this);
        this.toggleRemoveFolder = this.toggleRemoveFolder.bind(this);
        this.toggleSelected = this.toggleSelected.bind(this);
        this.loadSubFolder = this.loadSubFolder.bind(this);
        this.hideModals = this.hideModals.bind(this);
        this.state = {
            resourcesIsReady: false,
            currentFolder: '',
            parentFolder: '/',
            selectedFolder: '',
            newFolder: '',
            selectedFile: '',
            folders: [
                {
                    key: 'root',
                    label: '\\',
                    nodes: [
                        {

                        },
                    ],
                },                
            ],
            files:[],
            newFoldertooltipOpen: false,
            removeFoldertooltipOpen: false,
            newrefreshFoldertooltipOpen: false,
            newFiletooltipOpen: false,
            removeFiletooltipOpen: false,
            isLoading: false,
            folderName: `/`,
        }
    }


    componentDidMount() {
        this.setState({ isLoading: true });
        fetch(`/api/${this.props.match.params.client}/${this.props.match.params.project}/FileBrowser${this.state.folderName}`)
            .then(response => {
                if (response.ok) {
                    //console.log(this.state.folderName);
                    //console.log(response);
                    return response.json();
                } else {
                    //console.log(this.state.folderName);
                    //console.log(response);
                    throw new Error('Something went wrong ...');
                }
            })
            .then(data => this.setState({ files: data, isLoading: false }));
        //if (this.props.value) {
        //    api
        //        .get(`/${this.props.match.params.client}/${this.props.match.params.project}${this.state.url}`)
        //        .then(response => this.setState({ src: response.data.src }));
        //}
        let resourcesIsReady = true;

        this.setState({ resourcesIsReady: resourcesIsReady});
    }

    filesDone = 0;
    filesToDo = 0;

    highlight(e) {
        e.preventDefault();
        e.stopPropagation();
        this.refs.dropArea.classList.add('highlight');
    }

    unhighlight(e) {
        e.preventDefault();
        e.stopPropagation();
        this.refs.dropArea.classList.remove('highlight');
    }

    handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.files = e.dataTransfer.files;
        this.unhighlight(e);
        this.handleFiles(this.files);
    }

    handleFiles(files) {
        if (this.props.disabled) return;
        if (files.length === 0) {
            files = [...files.target.files];
        }
        this.initializeProgress(files.length);
        for (var i = 0; i < files.length; i++) {
            this.processFile(files[i])
                .then(this.uploadFile)
                .then(this.previewFile(files[i]))
                .then(this.loadSubFolder(this.state.folderName));            
        }
    }

    uploadFile(file) {
        let resource = {
            FileName: this.state.folderName.replace(/\/+/g, "") + this.state.folderName.replace(/\/+/g, "").length > 0 ? `\\` : '' + file.name, DataUrl: file.dataURL, FileToReplace: this.state.url, FolderName: this.state.folderName };
        return api
            .post(`/${this.props.match.params.client}/${this.props.match.params.project}/Resources/Upload`, resource)
            .then(response => response.data)
            .then(this.progressDone())
            .then(this.loadSubFolder(this.state.folderName))
            .catch((ex) => { console.log(ex);/* Error. Inform the user */ });
    }

    addNameToDataURL(dataURL, name) {
        return dataURL.replace(";base64", `;name=${encodeURIComponent(name)};base64`);
    }

    processFile(file) {
        const { name, size, type } = file;
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = reject;
            reader.onload = event => {
                resolve({
                    dataURL: this.addNameToDataURL(event.target.result, name),
                    name,
                    size,
                    type,
                });
            };
            reader.readAsDataURL(file);
        });
    }

    previewFile(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function () {
            let img = document.createElement('img');
            img.src = reader.result;
            document.getElementById('gallery').appendChild(img);
        }
    }

    initializeProgress(numfiles) {
        if (this.state.resourcesIsReady) {
            this.progressBar.current.value = 0;
            this.filesDone = 0;
            this.filesToDo = numfiles;
        }
        
    }

    progressDone() {
        this.filesDone++;
        this.progressBar.current.value = this.filesDone / this.filesToDo * 100
    }

    removeFolder(e) {
        e.preventDefault();
        if (this.refs.FileContainer.childNodes.length !== 0) {
            for (let i = 0; i < this.refs.FileContainer.childNodes.length; i++) {
                if (this.refs.FileContainer.childNodes[i].className.includes("Selected") && this.state.files[i].key === this.refs.FileContainer.childNodes[i].childNodes[0].childNodes[0].alt && this.state.files[i].AssetType === 0) {
                    var bodyJSON = JSON.stringify(`RemoveFolder:/${this.state.files[i].key}`);
                    fetch(`/api/${this.props.match.params.client}/${this.props.match.params.project}/FileBrowser/`, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            'Access-Control-Allow-Origin': '*'
                        },
                        body: bodyJSON
                    })
                        .then(response => response.json()) 
                        .then(this.refreshFolder(e))
                        .then(this.toggleSelected(i));
                }
            }
        }
    }

    removeFile(e) {
        e.preventDefault();
        if (this.refs.FileContainer.childNodes.length !== 0) {
            for (let i = 0; i < this.refs.FileContainer.childNodes.length; i++) {
                if (this.refs.FileContainer.childNodes[i].className.includes("Selected") && this.state.files[i].key === this.refs.FileContainer.childNodes[i].childNodes[0].childNodes[0].alt && this.state.files[i].AssetType === 1) {
                    var bodyJSON = JSON.stringify(`RemoveFile:/${this.state.files[i].key}`);
                    fetch(`/api/${this.props.match.params.client}/${this.props.match.params.project}/FileBrowser/`, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            'Access-Control-Allow-Origin': '*'
                        },
                        body: bodyJSON
                    })
                        .then(response => response.json())
                        .then(this.refreshFolder(e))
                        .then(this.toggleSelected(i));
                }
            }
        }
    }

    addFolder(e) {
        e.preventDefault();
        var newFolderString = this.NewFolderText.current.value;
        if (newFolderString.match(/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/i)) {
            fetch(`/api/${this.props.match.params.client}/${this.props.match.params.project}/FileBrowser/`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify(`CreateFolder:/${this.state.folderName}:/${this.NewFolderText.current.value}`)
            })
                .then(response => response.json())
                .then(this.refreshFolder(e));

            this.NewFolderRef.current.classList.add("hidden");
        }
        
    }

    refreshFolder(e) {
        e.preventDefault();
        this.loadSubFolder(this.state.folderName);
    }

    loadSubFolder(folderName) {
        if (folderName !== this.state.folderName) {
            this.setState({ folderName: folderName })
        }
        this.setState({ isLoading: true });

        if (!this.state.parentFolder.includes(folderName) && folderName !== '/') {
            this.state.currentFolder !== '/' ? 
                this.setState({ parentFolder: this.state.parentFolder + this.state.currentFolder })
                : this.setState({ parentFolder: this.state.parentFolder})
            
        } else {
            var newFolder = this.state.parentFolder.replace(folderName, '');
            if (newFolder === '') { newFolder = '/' };
            this.setState({ parentFolder: newFolder});
        }
        this.setState({ currentFolder: folderName });
        fetch(`/api/${this.props.match.params.client}/${this.props.match.params.project}/FileBrowser${folderName}`)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Something went wrong ...');
                }
            })
            .then(data => this.setState({ files: data, isLoading: false }));
    }

    getNewFolderName(e) {
        e.preventDefault();
        this.NewFolderRef.current.classList.remove("hidden");
    }

    toggleNewFolder() {
        this.setState({
            newFoldertooltipOpen: !this.state.newFoldertooltipOpen
        });
    }

    toggleRemoveFolder() {
        this.setState({
            removeFoldertooltipOpen: !this.state.removeFoldertooltipOpen
        });
    }

    toggleRefreshFolder() {
        this.setState({
            refreshFoldertooltipOpen: !this.state.refreshFoldertooltipOpen
        });
    }

    toggleNewFile() {
        this.setState({
            newFiletooltipOpen: !this.state.newFiletooltipOpen
        });
    }

    toggleRemoveFile() {
        this.setState({
            removeFiletooltipOpen: !this.state.removeFiletooltipOpen
        });
    }

    toggleSelected(i) {
        if (this.refs.FileContainer.childNodes.length !== 0 && i < this.refs.FileContainer.childNodes.length) {
            if (!this.refs.FileContainer.childNodes[i].className.includes("Selected")) {
                this.refs.FileContainer.childNodes[i].classList.add("Selected");
            } else {
                this.refs.FileContainer.childNodes[i].classList.remove("Selected");
            }
        }
    }

   

    hideModals(e) {
        e.preventDefault();
        if (e.target.className.includes("modalBG")) {
            this.NewFolderRef.current.classList.add("hidden");
        }
    }

    render() {
        const { files } = this.state;
        var myThis = this;
        const resources = 
            <div className="fullwidth">
                <style dangerouslySetInnerHTML={{
                    __html: `
                    #drop-area {
                        border: 2px dashed #ccc;
                        border-radius: 20px;
                        width: 480px;
                        font-family: sans-serif;
                        margin: 30px auto;
                        padding: 20px;
                    }
                    #drop-area.highlight {
                        border-color: purple;
                    }
                    p {
                        margin-top: 0;
                    }
                    .my-form {
                        margin-bottom: 10px;
                    }
                    #gallery {
                        margin-top: 10px;
                    }
                    #gallery img {
                        width: 150px;
                        margin-bottom: 10px;
                        margin-right: 10px;
                        vertical-align: middle;
                    }
                    .button {
                        display: inline-block;
                        padding: 10px;
                        background: #ccc;
                        cursor: pointer;
                        border-radius: 5px;
                        border: 1px solid #ccc;
                    }
                    .button:hover {
                        background: #ddd;
                    }
                    #fileElem {
                        display: none;
                    }
                    #files {
                        width:100%;
                        height:50vh;
                        background: #fff;
                        display: inline-block;
                        border: 2px solid #eee;
                    }
                    #folders {
                        width:100%;
                        height:50vh;
                        background: #fff;
                        display: inline-block;
                        border: 2px solid #eee;
                    }
                    #fileTools {
                        width:100%;
                        background: #eee;
                        display: inline-block;
                        padding:5px 0 2px 5px;
                        border-top: 2px solid #20223b;
                        border-bottom: 2px solid #20223b;
                    }
                    #folderTools {
                        width:100%;
                        height:4vh;
                        background: #eee;
                        display: inline-block;
                        padding-left:10px;
                    }#folderPane {
                        width:98%;
                        margin-left:auto;
                        margin-right:auto;
                    }
                    .FileBrowser.Folder{
                        width:30%;
                        display:inline-block;
                        background: #fff;
                        display: inline-block;
                        border: 2px solid #d7d7d7;
                        height:65vh;
                    }
                    .FileBrowser.File{
                        height:94vh;
                        background: #fff;
                        overflow:hidden;
                        margin-left:310px;
                    }
                    #filePane{   
                        height:60%;
                        overflow-y:auto;
                        background:#f3f3f3;
                        border-bottom: 2px solid #20223b;
                        margin:2px;
                    }
                    img.barButton {
                        //height:4vh;
                    }.barButton {
                        height:4vh;
                        display: inline-block;
                        padding: 5px;
                        background: #ddd;
                        cursor: pointer;
                        border-radius: 5px;
                        border: 1px solid #929292;
                    }
                    .barButton:hover {
                        background: #d3d3d3;
                    }
                    #hidden{
                        display:none;
                    }
                    .modal{
                        border: 1px solid #ddd;
                        background:#fff;
                        border-radius: 5px;
                        display:block;
                        position:relative;
                        margin-left:auto;
                        margin-right:auto;
                        top:40%;
                        width: 200px;
                        height: 100px;
                        padding:5px;
                    }
                    .modalButton {
                        display: inline-block;
                        padding: 6px;
                        background: #ccc;
                        cursor: pointer;
                        border-radius: 5px;
                        border: 1px solid #ccc;
                        text-align:center;
                    }
                    .modalButton:hover {
                        background: #ddd;
                    }
                    .modalElement{
                        margin:5px;
                        width:95%;
                    }
                    .FileFolder{
                        height:126px;
                        width:126px;
                        padding:2px;
                        display:inline-block;
                        font-size:10px;
                        vertical-align:top;
                        margin:2px;
                    }
                    .FileFolder:hover{
                        background:#d3d3d3;
                        border-radius: 5px;
                        border: 1px solid #929292;

                    }
                    .Selected{
                        background:#bed8d4;
                        border-radius: 5px;
                        border: 1px solid #929292;
                    }
                    .FileFolderIcon{
                        max-width:96px;
                        max-height:96px;
                        margin:auto;
                    }
                    .FileFolderContents{
                        height:100%;
                        width:100%;
                        display:flex;
                        justify-content:flex-end;
                        flex-direction:column;
                        text-align:center;
                    }
                    .modalBG {
                        width:100%;
                        height:100%;
                        display:block;
                        position:absolute;
                        margin-left:auto;
                        margin-right:auto;
                        top:0;
                    }
                    .sidebar{
                        display:inline-block;
                    }

                `}} />

                <Menu className="sidebar sidebar-inverse pr-0 pl-0" client={this.props.match.params.client} project={this.props.match.params.project} />
                <div className="FileBrowser File fix-top">
                    <div id="fileTools">
                        <label id="newFolder" htmlFor="newFolderName" onClick={(e) => myThis.getNewFolderName(e)}><img className="barButton mr-sm" src={folderAdd} alt="New Folder" /></label>
                        <Tooltip placement="right" isOpen={this.state.newFoldertooltipOpen} target="newFolder" toggle={this.toggleNewFolder}>New Folder</Tooltip>
                        <label id="removeFolder" onClick={(e) => window.confirm("Are you sure you wish to delete this item?") && myThis.removeFolder(e)}><img className="barButton mr-sm" src={folderRemove} alt="Remove Folder" /></label>
                        <Tooltip placement="right" isOpen={this.state.removeFoldertooltipOpen} target="removeFolder" toggle={this.toggleRemoveFolder}>Remove Folder</Tooltip>
                        <label id="refreshFolder" onClick={(e) => myThis.refreshFolder(e)}><img className="barButton mr-sm" src={folderRefresh} alt="Refresh Folder" /></label>
                        <Tooltip placement="right" isOpen={this.state.refreshFoldertooltipOpen} target="refreshFolder" toggle={this.toggleRefreshFolder}>Refresh Folder</Tooltip>
                        <label id="addFile" htmlFor="fileElem"><img className="barButton mr-sm" src={fileAdd} alt="Add File" /></label>
                        <Tooltip placement="right" isOpen={this.state.newFiletooltipOpen} target="addFile" toggle={this.toggleNewFile}></Tooltip>
                        <label id="removeFile" onClick={(e) => window.confirm("Are you sure you wish to delete this item?") && myThis.removeFile(e)}><img className="barButton mr-sm" src={fileRemove} alt="Remove File" /></label>
                        <Tooltip placement="right" isOpen={this.state.removeFiletooltipOpen} target="removeFile" toggle={this.toggleRemoveFile}></Tooltip>
                    </div>
                    <div id="filePane" ref="FileContainer">
                        
                        {files.map(function (item, i) {
                            
                            if (item.key.substring(item.key.length - 5, item.key.length - 3).includes(".")) {
                                return <div id={i} key={i} className="FileFolder" onClick={(e) => myThis.toggleSelected(i)}>
                                    <div className="FileFolderContents">
                                        <img src={item.imageData} alt={item.key} className="FileFolderIcon" />
                                        <br />{item.key.replace(item.Folder, "")}
                                    </div>
                                </div>
                            } else {
                                if (item.Folder === `(root)`) {
                                    var rootFolderName = myThis.state.parentFolder;
                                    return <div id={i} key={i} className="FileFolder" onDoubleClick={(e) => myThis.loadSubFolder(rootFolderName)} onClick={(e) => myThis.toggleSelected(i)}>
                                        <div className="FileFolderContents">
                                            <img src={item.imageData} alt={item.key} className="FileFolderIcon" />
                                            <br />(parent folder)
                                        </div>
                                    </div>
                                } else {
                                    var chosenFolderName = '/' + item.Filename + '/';
                                    return <div id={i} key={i} className="FileFolder" onDoubleClick={(e) => myThis.loadSubFolder(chosenFolderName)} onClick={(e) => myThis.toggleSelected(i)}>
                                        <div className="FileFolderContents">
                                            <img src={item.imageData} alt={item.key} className="FileFolderIcon" />
                                            <br />{item.key}
                                        </div>
                                    </div>
                                }
                            }
                        })}
                    </div>
                    <div id="drop-area" ref="dropArea" onDragEnter={(e) => myThis.highlight(e)} onDragOver={(e) => myThis.highlight(e)} onDragLeave={(e) => myThis.unhighlight(e)} onDrop={(e) => myThis.handleDrop(e)}>
                        <form className="my-form">
                            <p>Upload multiple files with the file dialog or by dragging and dropping images onto the dashed region</p>
                            <input type="file" id="fileElem" multiple accept="image/*,.pdf" onChange={this.handleFiles} />
                            <label className="button" htmlFor="fileElem">Select some files</label>
                        </form>
                        <div id="gallery"></div>
                        <progress id="progress-bar" ref={this.progressBar} max="100" value="0"></progress>
                    </div>
                </div>
                <div className="modalBG hidden" onClick={(e) => myThis.hideModals(e)} ref={this.NewFolderRef}>
                    <div id="createNewFolder" className="modal" >
                        <input type="text" id="newFolderName" ref={this.NewFolderText} className="modalElement" pattern="^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$"/>
                        <label className="modalButton modalElement" onClick={this.addFolder}>Create Folder</label>
                    </div>
                </div>
                
                
            </div>
        return resources;
        
    }
}

const Image = withRouter(Resources);

function ResourceUploader(props) {
    //const {
    //    id,
    //    value,
    //    disabled,
    //    readonly,
    //    autofocus,
    //} = props;

    return (
        <Image {...props} />
    );
}

export default connect(null, { alertSuccess })(ResourceUploader);